import { FC } from 'react';
import { State } from 'redux/initialState';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';

import { dateFormat, dateFormatYear } from 'constants/formats';

import { formatCurrencyDecimals } from 'utils/formats';

import DocumentsColumn from 'modules/_shared/components/DocumentsColumn';
import { usePartnerDividends } from '../context/PartnerDividendsContext';
import { DividendData } from '../types/DividendData';

type DividendsTableRowProps = {
  index: number;
  dividend: DividendData;
};

const DividendsTableRow: FC<DividendsTableRowProps> = ({ dividend, index }) => {
  const { data } = usePartnerDividends();

  const {
    date,
    ndPercentage,
    totalAmount,
    amount,
    retentionAmount,
    retentionPercentage,
    documents = [],
  } = dividend;

  const formattedDate = new Date(date).toISOString().split('T')[0];
  const dividendDocumentName = `Dividendo_${formattedDate}.pdf`;

  const actualSociety = useSelector(
    (state: State) => state.society.actualSociety
  );

  const { dividendsTemplateDocument } = data;

  return (
    <>
      <td className="text-left vertical-align-middle d-none d-md-table-cell w-20px">
        <b>{index}</b>
      </td>

      <td className="text-left vertical-align-middle pl-2 pl-md-2">
        {format(
          new Date(date),
          data.isSummaryView ? dateFormatYear : dateFormat
        )}
      </td>

      <td className="text-right vertical-align-middle d-none d-md-table-cell">
        {formatCurrencyDecimals(totalAmount)}
      </td>

      <td className="text-right vertical-align-middle">
        {(ndPercentage || 0).toFixed(2)}%
      </td>

      <td className="text-right vertical-align-middle d-none d-md-table-cell">
        {formatCurrencyDecimals(amount || 0)}
      </td>

      <td className="text-right vertical-align-middle d-none d-md-table-cell">
        {(retentionPercentage || 0).toFixed(2)}%
      </td>

      <td className="text-right vertical-align-middle pr-2 pr-md-3">
        {formatCurrencyDecimals(amount - retentionAmount || 0)}
      </td>

      {!data.isSummaryView && (
        <>
          <DocumentsColumn
            index={index}
            documentsCount={documents.length || 0}
            documents={documents || []}
            tableView
            hideOnMobile={false}
          />

          <DocumentsColumn
            index={index}
            documentsCount={dividendsTemplateDocument ? 1 : 0}
            documents={
              dividendsTemplateDocument
                ? [{ ...dividendsTemplateDocument, name: dividendDocumentName }]
                : []
            }
            sources={{
              society: actualSociety?._id,
              partner: dividend.partnerId,
              dividend: dividend.operationId,
            }}
            tableView
            hideOnMobile={false}
          />
        </>
      )}
    </>
  );
};
export default DividendsTableRow;
